import { chakra } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export const RouterLink = chakra(Link);
